import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class CreatorDashboardProfileSocials extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="flex flex-col h-80 w-8/12 mt-8">
        <div className="text-white font-semibold text-lg mb-4">
          SOCIALS
        </div>
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            Instagram
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="instagram"
                value={this.props.instagram}
                onChange={this.props.setInstagram}
              />
            </form>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            Twitter
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="twitter"
                value={this.props.twitter}
                onChange={this.props.setTwitter}
              />
            </form>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            Discord
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="discord"
                value={this.props.discord}
                onChange={this.props.setDiscord}
              />
            </form>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-zinc-400 font-semibold text-md">
            Spotify
          </div>
          <div>
            <form className="flex">
              <input
                className="border-zinc-600 rounded-md border bg-custom-gray text-zinc-400 h-10 w-full px-2"
                type="text"
                name="spotify"
                value={this.props.spotify}
                onChange={this.props.setSpotify}
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CreatorDashboardProfileSocials;
